import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

import Image from 'src/components/image';
import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import { varFade, MotionViewport } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function HomeCombination() {


  return (
    <Container
      component={MotionViewport}
      sx={{
        position: 'relative',
        pt: { xs: 0, md: 0 },
        pb: { xs: 5, md: 5 },
        textAlign: { xs: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          borderRadius: 3,
          p: { xs: 2, md: 10 },
          bgcolor: { xs: 'transparent', md: 'background.neutral' },
        }}
      >

        <m.div variants={varFade().inUp}>
          <Typography variant="h3" sx={{ my: 3 }}>
            Müde, Zeit und Geld  <br />
            zu verschwenden?
          </Typography>
        </m.div>
        <Box sx={{ mb: 2 }}>
        <m.div variants={varFade().inUp}>
          <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                Lass uns Dir helfen, dein Digital zu führen!
          </Typography>
        </m.div>
        </Box>
        <m.div variants={varFade().inUp}>
          <Typography
            sx={{
              color: 'text.secondary',
              maxWidth: 460,
              mx: {
                xs: 'auto',
                md: 'unset',
              },
            }}
          >
             Deine Zeit ist kostbar. Wir kümmern uns um das Digitale, während du dich auf den Erfolg deine Brand konzentrierst.
          </Typography>
        </m.div>

        <m.div variants={varFade().inLeft}>
      <Button
        component={Link} 
        size="large"
        color="inherit"
        variant="outlined"
        target="_blank"
        rel="noopener"
        href={paths.minimalStore}
        endIcon={<Iconify icon="carbon:chevron-right" width={16} />}
        sx={{ mt: 5 }}
        to="/agentur/kontakt"
      >
        Jetzt kostenloses Beratungsgespräch vereinbaren!
      </Button>
    </m.div>
      </Box>

      <Box
        sx={{
          top: { md: 120, lg:90 },
          right: { md: -40, lg:-120, },
          my: { xs: 2, md: 0 },
          position: { md: 'absolute' },
        }}
      >
        <m.div variants={varFade().inDown}>
          <Image
            alt="minimal dashboard"
            src="/assets/images/home/minimal_dashboard.png"
            sx={{
              maxWidth: { xs:500, md: 490, lg:690 },
            }}
          />
        </m.div>
      </Box>

    
    </Container>
  );
}
